import { StoreState } from "../types";
import { UserManageable } from "./types";

export const loginReducer = (
  state: StoreState, token: string
) => {
  localStorage.setItem(
    "token",
    token
  );

  return {
    ...state,
    token,
  };
};

export const logoutReducer = (state: StoreState) => {
  localStorage.clear();

  return {
    ...state,
    currentUser: new UserManageable(null),
    token: "",
  };
};

export const storeCurrentUserReducer = (
  state: StoreState,
  currentUser: UserManageable
) => {
  localStorage.setItem(
    "userDetails",
    JSON.stringify(currentUser)
  );

  return {
    ...state,
    currentUser,
  };
};

export const languageReducer = (
  state: StoreState, language: string
) => {
  localStorage.setItem(
    "language",
    language
  );

  return {
    ...state,
    language,
  };
};